import NavUrl from './NavUrl';
const LinkMethods = {
  date () {
    return {

    }
  },
  mixins: [NavUrl],
  methods: {
    indexGo (url) {
      // this.$router.replace('/')
      window.open(this.homeUrl, '_self')
    },

    linkGo (url) {
      // this.$router.push(this.$i18n.path(url))
    }
  }
}

export default LinkMethods
